import { IconFont } from '@byecode/ui'
import styled from 'styled-components'

export const PreviewContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 30%;
`

export const Wrapper = styled.div`
    display: flex;
    align-items: center;
    border-radius: 6px;
    overflow: hidden;
    background-color: var(--color-gray-100);
    padding: 2px;
    gap: 2px;
`

export const IconWrapper = styled.div<{ hoverColor?: string }>`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    width: 28px;
    cursor: pointer;
    border-radius: 5px;

    &.active {
        background-color: var(--color-white);
    }

    &.open {
        background-color: var(--color-gray-200);
    }

    &:not(.active):hover {
        background-color: ${({ hoverColor }) => hoverColor};
    }
`

export const MainBreakPointLogo = styled(IconFont)`
    color: var(--color-main);
    position: absolute;
    right: 1px;
    top: 0;
`

export const Box = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px;
    box-shadow: 0px 2px 8px 0px #00000026;
`

export const Title = styled.div`
    color: var(--color-white);
    font-size: var(--font-size-sm);
`

export const Description = styled.div`
    color: var(--color-gray-400);
    font-size: var(--font-size-sm);
`
